import { configure } from '@js-boot/logger';
import { logHttpSink, logLevel } from '../config';

const logSink = logHttpSink();

const { getLogger, getDefaultLogger } = configure({
  level: logLevel(),
  http: logSink ? { url: logSink } : undefined,
});

export { getLogger, getDefaultLogger };
